module.exports = __webpack_public_path__ + "static/media/Pugna.cae21a82.png";